const analyticsTest = {
  id: 'analytics',
  name: 'Product Analytics',
  subtitle: 'Mock interview · Data Engineer loop',
  description: 'User engagement tracking and funnel analysis',
  pinnedNow: '2026-04-14 12:00:00',

  schema: `
    CREATE TABLE users (
      user_id TEXT PRIMARY KEY,
      created_at TEXT,
      plan_type TEXT,
      country TEXT
    );

    CREATE TABLE sessions (
      session_id TEXT PRIMARY KEY,
      user_id TEXT,
      started_at TEXT,
      ended_at TEXT,
      device_type TEXT,
      FOREIGN KEY (user_id) REFERENCES users(user_id)
    );

    CREATE TABLE events (
      event_id TEXT PRIMARY KEY,
      session_id TEXT,
      event_type TEXT,
      event_time TEXT,
      page_path TEXT,
      FOREIGN KEY (session_id) REFERENCES sessions(session_id)
    );

    CREATE TABLE conversions (
      conversion_id TEXT PRIMARY KEY,
      user_id TEXT,
      converted_at TEXT,
      revenue REAL,
      FOREIGN KEY (user_id) REFERENCES users(user_id)
    );
  `,

  seedDataFn: (db) => {
    // Users
    const users = [
      ['u1','2026-03-01 10:00','free','US'],
      ['u2','2026-03-02 11:00','free','UK'],
      ['u3','2026-03-03 09:00','free','US'],
      ['u4','2026-03-04 14:00','free','CA'],
      ['u5','2026-03-05 15:00','free','US'],
      ['u6','2026-03-06 08:00','free','UK'],
      ['u7','2026-03-07 10:00','free','US'],
      ['u8','2026-03-08 12:00','free','CA'],
      ['u9','2026-03-09 09:00','free','US'],
      ['u10','2026-03-10 11:00','free','UK'],
      ['u11','2026-04-01 10:00','free','US'],
      ['u12','2026-04-02 11:00','free','US'],
      ['u13','2026-04-05 09:00','free','UK'],
      ['u14','2026-04-06 14:00','free','CA'],
      ['u15','2026-04-07 10:00','free','US']
    ];

    const userStmt = db.prepare(
      'INSERT INTO users (user_id, created_at, plan_type, country) VALUES (?, ?, ?, ?)'
    );
    users.forEach(u => userStmt.run(u));
    userStmt.free();

    // Sessions - Q1: Need distinct users by device in last 7 days
    const sessions = [
      // Recent sessions (last 7 days from 2026-04-14 12:00:00)
      ['s1','u1','2026-04-08 10:00','2026-04-08 10:30','mobile'],   // Q1: mobile
      ['s2','u2','2026-04-08 11:00','2026-04-08 11:20','desktop'],  // Q1: desktop
      ['s3','u3','2026-04-09 09:00','2026-04-09 09:45','mobile'],   // Q1: mobile
      ['s4','u1','2026-04-09 14:00','2026-04-09 14:15','desktop'],  // Q1: u1 on desktop (multi-device)
      ['s5','u4','2026-04-10 10:00','2026-04-10 10:20','tablet'],   // Q1: tablet
      ['s6','u5','2026-04-10 11:00','2026-04-10 11:30','mobile'],   // Q1: mobile
      ['s7','u6','2026-04-11 08:00','2026-04-11 08:40','desktop'],  // Q1: desktop
      ['s8','u7','2026-04-11 09:00','2026-04-11 09:25','mobile'],   // Q1: mobile
      ['s9','u8','2026-04-12 12:00','2026-04-12 12:35','desktop'],  // Q1: desktop
      ['s10','u9','2026-04-13 10:00','2026-04-13 10:15','mobile'],  // Q1: mobile
      ['s11','u10','2026-04-13 14:00','2026-04-13 14:20','tablet'], // Q1: tablet
      ['s12','u11','2026-04-14 09:00','2026-04-14 09:30','desktop'], // Q1: desktop

      // Older sessions (for Q2 cohort analysis)
      ['s13','u1','2026-03-01 11:00','2026-03-01 11:20','desktop'], // signup day
      ['s14','u1','2026-03-08 10:00','2026-03-08 10:15','mobile'],  // 7 days later (retained)
      ['s15','u2','2026-03-02 12:00','2026-03-02 12:30','desktop'], // signup day
      ['s16','u2','2026-03-09 11:00','2026-03-09 11:15','desktop'], // 7 days later (retained)
      ['s17','u3','2026-03-03 10:00','2026-03-03 10:25','desktop'], // signup day
      // u3 NO session on day 7 (not retained)
      ['s18','u4','2026-03-04 15:00','2026-03-04 15:20','mobile'],  // signup day
      ['s19','u4','2026-03-11 14:00','2026-03-11 14:30','mobile'],  // 7 days later (retained)
      ['s20','u5','2026-03-05 16:00','2026-03-05 16:20','desktop'], // signup day
      // u5 NO session on day 7 (not retained)
      ['s21','u6','2026-03-06 09:00','2026-03-06 09:30','desktop'], // signup day
      ['s22','u6','2026-03-13 08:00','2026-03-13 08:20','desktop'], // 7 days later (retained)

      // Q3 funnel sessions with events
      ['s23','u11','2026-04-01 11:00','2026-04-01 11:30','desktop'],
      ['s24','u12','2026-04-02 12:00','2026-04-02 12:20','mobile'],
      ['s25','u13','2026-04-05 10:00','2026-04-05 10:40','desktop'],
      ['s26','u14','2026-04-06 15:00','2026-04-06 15:25','desktop'],
      ['s27','u15','2026-04-07 11:00','2026-04-07 11:15','mobile']
    ];

    const sessionStmt = db.prepare(
      'INSERT INTO sessions (session_id, user_id, started_at, ended_at, device_type) VALUES (?, ?, ?, ?, ?)'
    );
    sessions.forEach(s => sessionStmt.run(s));
    sessionStmt.free();

    // Events - Q3: Funnel analysis (page_view -> add_to_cart -> checkout -> purchase)
    const events = [
      // u11: Complete funnel (view -> cart -> checkout -> purchase)
      ['e1','s23','page_view','2026-04-01 11:05','/product/laptop'],
      ['e2','s23','add_to_cart','2026-04-01 11:10','/product/laptop'],
      ['e3','s23','checkout','2026-04-01 11:15','/checkout'],
      ['e4','s23','purchase','2026-04-01 11:20','/confirmation'],

      // u12: Stopped at add_to_cart
      ['e5','s24','page_view','2026-04-02 12:05','/product/mouse'],
      ['e6','s24','add_to_cart','2026-04-02 12:10','/product/mouse'],

      // u13: Complete funnel
      ['e7','s25','page_view','2026-04-05 10:05','/product/keyboard'],
      ['e8','s25','add_to_cart','2026-04-05 10:12','/product/keyboard'],
      ['e9','s25','checkout','2026-04-05 10:18','/checkout'],
      ['e10','s25','purchase','2026-04-05 10:25','/confirmation'],

      // u14: Stopped at checkout
      ['e11','s26','page_view','2026-04-06 15:05','/product/monitor'],
      ['e12','s26','add_to_cart','2026-04-06 15:10','/product/monitor'],
      ['e13','s26','checkout','2026-04-06 15:15','/checkout'],

      // u15: Only page_view
      ['e14','s27','page_view','2026-04-07 11:05','/product/desk'],

      // Additional noise events for other sessions
      ['e15','s1','page_view','2026-04-08 10:05','/home'],
      ['e16','s2','page_view','2026-04-08 11:05','/pricing'],
      ['e17','s3','page_view','2026-04-09 09:10','/about']
    ];

    const eventStmt = db.prepare(
      'INSERT INTO events (event_id, session_id, event_type, event_time, page_path) VALUES (?, ?, ?, ?, ?)'
    );
    events.forEach(e => eventStmt.run(e));
    eventStmt.free();

    // Conversions
    const conversions = [
      ['c1','u11','2026-04-01 11:20',899.99],  // Completed funnel
      ['c2','u13','2026-04-05 10:25',79.99]    // Completed funnel
    ];

    const convStmt = db.prepare(
      'INSERT INTO conversions (conversion_id, user_id, converted_at, revenue) VALUES (?, ?, ?, ?)'
    );
    conversions.forEach(c => convStmt.run(c));
    convStmt.free();
  },

  questions: [
    {
      id: 1,
      difficulty: 'Warm-up',
      timeLimit: 600, // 10 minutes
      question: `Calculate Daily Active Users (DAU) by device type for the last 7 days. A user is "active" on a given day if they had at least one session that started on that day.

Return: activity_date (YYYY-MM-DD format), device_type, active_users (count of distinct users). Sort by date DESC, then device_type ASC.

Note: "now" is pinned at 2026-04-14 12:00:00. Use datetime('2026-04-14 12:00:00', '-7 days') for the date filter.`,
      referenceSQL: `
        SELECT
          DATE(s.started_at) AS activity_date,
          s.device_type,
          COUNT(DISTINCT s.user_id) AS active_users
        FROM sessions s
        WHERE s.started_at >= datetime('2026-04-14 12:00:00', '-7 days')
        GROUP BY DATE(s.started_at), s.device_type
        ORDER BY activity_date DESC, s.device_type ASC
      `,
      solutionSQL: `SELECT
  DATE(s.started_at) AS activity_date,
  s.device_type,
  COUNT(DISTINCT s.user_id) AS active_users
FROM sessions s
WHERE s.started_at >= datetime('2026-04-14 12:00:00', '-7 days')
GROUP BY DATE(s.started_at), s.device_type
ORDER BY activity_date DESC, s.device_type ASC`,
      expectedColumns: ['activity_date', 'device_type', 'active_users']
    },
    {
      id: 2,
      difficulty: 'Medium',
      timeLimit: 1200, // 20 minutes
      question: `Perform a cohort retention analysis. For users who signed up in March 2026 (created_at between '2026-03-01' and '2026-03-31'), calculate what percentage returned exactly 7 days after their signup date.

A user "returned" if they had at least one session that started on day 7 (i.e., between 7 days 0 hours and 7 days 23:59:59 after their created_at timestamp).

Return: cohort_month ('2026-03'), total_users, returned_users, retention_rate (rounded to 3 decimals).

Hint: Use DATE(created_at, '+7 days') to calculate the target return date, then check if any session started on that calendar day.`,
      referenceSQL: `
        WITH cohort_users AS (
          SELECT
            user_id,
            created_at,
            DATE(created_at, '+7 days') AS target_return_date
          FROM users
          WHERE created_at >= '2026-03-01' AND created_at < '2026-04-01'
        ),
        user_sessions AS (
          SELECT
            cu.user_id,
            MAX(CASE
              WHEN DATE(s.started_at) = cu.target_return_date THEN 1
              ELSE 0
            END) AS did_return
          FROM cohort_users cu
          LEFT JOIN sessions s ON s.user_id = cu.user_id
          GROUP BY cu.user_id
        )
        SELECT
          '2026-03' AS cohort_month,
          COUNT(*) AS total_users,
          SUM(did_return) AS returned_users,
          ROUND(CAST(SUM(did_return) AS REAL) / COUNT(*), 3) AS retention_rate
        FROM user_sessions
      `,
      solutionSQL: `WITH cohort_users AS (
  SELECT
    user_id,
    created_at,
    DATE(created_at, '+7 days') AS target_return_date
  FROM users
  WHERE created_at >= '2026-03-01' AND created_at < '2026-04-01'
),
user_sessions AS (
  SELECT
    cu.user_id,
    MAX(CASE
      WHEN DATE(s.started_at) = cu.target_return_date THEN 1
      ELSE 0
    END) AS did_return
  FROM cohort_users cu
  LEFT JOIN sessions s ON s.user_id = cu.user_id
  GROUP BY cu.user_id
)
SELECT
  '2026-03' AS cohort_month,
  COUNT(*) AS total_users,
  SUM(did_return) AS returned_users,
  ROUND(CAST(SUM(did_return) AS REAL) / COUNT(*), 3) AS retention_rate
FROM user_sessions`,
      expectedColumns: ['cohort_month', 'total_users', 'returned_users', 'retention_rate']
    },
    {
      id: 3,
      difficulty: 'Hard',
      timeLimit: 1800, // 30 minutes
      question: `Analyse the purchase funnel conversion for sessions in April 2026. Calculate step-by-step conversion rates through the following funnel:
1. page_view (events with event_type='page_view')
2. add_to_cart (event_type='add_to_cart')
3. checkout (event_type='checkout')
4. purchase (event_type='purchase')

For each funnel step, return:
- funnel_step (name of the step)
- sessions_reached (distinct sessions that reached this step)
- conversion_rate (percentage of sessions from step 1 that reached this step, rounded to 2 decimals)
- avg_time_to_step (average seconds from the first page_view to this step in the same session, NULL for step 1, rounded to 1 decimal)

Order by the standard funnel order: page_view, add_to_cart, checkout, purchase.

Important: A session "reaches" a step if it has at least one event of that type. Handle sessions that skip steps appropriately. Time should be calculated using julianday() for datetime difference.`,
      referenceSQL: `
        WITH april_sessions AS (
          SELECT DISTINCT s.session_id
          FROM sessions s
          WHERE s.started_at >= '2026-04-01' AND s.started_at < '2026-05-01'
        ),
        session_events AS (
          SELECT
            e.session_id,
            e.event_type,
            e.event_time,
            MIN(CASE WHEN e.event_type = 'page_view' THEN e.event_time END)
              OVER (PARTITION BY e.session_id) AS first_page_view_time
          FROM events e
          WHERE e.session_id IN (SELECT session_id FROM april_sessions)
        ),
        funnel_steps AS (
          SELECT
            session_id,
            MAX(CASE WHEN event_type = 'page_view' THEN 1 ELSE 0 END) AS reached_page_view,
            MAX(CASE WHEN event_type = 'add_to_cart' THEN 1 ELSE 0 END) AS reached_cart,
            MAX(CASE WHEN event_type = 'checkout' THEN 1 ELSE 0 END) AS reached_checkout,
            MAX(CASE WHEN event_type = 'purchase' THEN 1 ELSE 0 END) AS reached_purchase,
            MIN(CASE WHEN event_type = 'add_to_cart' THEN event_time END) AS first_cart_time,
            MIN(CASE WHEN event_type = 'checkout' THEN event_time END) AS first_checkout_time,
            MIN(CASE WHEN event_type = 'purchase' THEN event_time END) AS first_purchase_time,
            MIN(first_page_view_time) AS first_page_view
          FROM session_events
          GROUP BY session_id
        ),
        step_metrics AS (
          SELECT
            'page_view' AS funnel_step,
            1 AS step_order,
            SUM(reached_page_view) AS sessions_reached,
            NULL AS avg_seconds
          FROM funnel_steps
          UNION ALL
          SELECT
            'add_to_cart',
            2,
            SUM(reached_cart),
            AVG(CASE
              WHEN reached_cart = 1
              THEN (julianday(first_cart_time) - julianday(first_page_view)) * 86400
            END)
          FROM funnel_steps
          UNION ALL
          SELECT
            'checkout',
            3,
            SUM(reached_checkout),
            AVG(CASE
              WHEN reached_checkout = 1
              THEN (julianday(first_checkout_time) - julianday(first_page_view)) * 86400
            END)
          FROM funnel_steps
          UNION ALL
          SELECT
            'purchase',
            4,
            SUM(reached_purchase),
            AVG(CASE
              WHEN reached_purchase = 1
              THEN (julianday(first_purchase_time) - julianday(first_page_view)) * 86400
            END)
          FROM funnel_steps
        ),
        total_sessions AS (
          SELECT SUM(reached_page_view) AS total
          FROM funnel_steps
        )
        SELECT
          sm.funnel_step,
          sm.sessions_reached,
          ROUND(CAST(sm.sessions_reached AS REAL) / ts.total * 100, 2) AS conversion_rate,
          ROUND(sm.avg_seconds, 1) AS avg_time_to_step
        FROM step_metrics sm
        CROSS JOIN total_sessions ts
        ORDER BY sm.step_order
      `,
      solutionSQL: `WITH april_sessions AS (
  SELECT DISTINCT s.session_id
  FROM sessions s
  WHERE s.started_at >= '2026-04-01' AND s.started_at < '2026-05-01'
),
session_events AS (
  SELECT
    e.session_id,
    e.event_type,
    e.event_time,
    MIN(CASE WHEN e.event_type = 'page_view' THEN e.event_time END)
      OVER (PARTITION BY e.session_id) AS first_page_view_time
  FROM events e
  WHERE e.session_id IN (SELECT session_id FROM april_sessions)
),
funnel_steps AS (
  SELECT
    session_id,
    MAX(CASE WHEN event_type = 'page_view' THEN 1 ELSE 0 END) AS reached_page_view,
    MAX(CASE WHEN event_type = 'add_to_cart' THEN 1 ELSE 0 END) AS reached_cart,
    MAX(CASE WHEN event_type = 'checkout' THEN 1 ELSE 0 END) AS reached_checkout,
    MAX(CASE WHEN event_type = 'purchase' THEN 1 ELSE 0 END) AS reached_purchase,
    MIN(CASE WHEN event_type = 'add_to_cart' THEN event_time END) AS first_cart_time,
    MIN(CASE WHEN event_type = 'checkout' THEN event_time END) AS first_checkout_time,
    MIN(CASE WHEN event_type = 'purchase' THEN event_time END) AS first_purchase_time,
    MIN(first_page_view_time) AS first_page_view
  FROM session_events
  GROUP BY session_id
),
step_metrics AS (
  SELECT
    'page_view' AS funnel_step,
    1 AS step_order,
    SUM(reached_page_view) AS sessions_reached,
    NULL AS avg_seconds
  FROM funnel_steps
  UNION ALL
  SELECT
    'add_to_cart',
    2,
    SUM(reached_cart),
    AVG(CASE
      WHEN reached_cart = 1
      THEN (julianday(first_cart_time) - julianday(first_page_view)) * 86400
    END)
  FROM funnel_steps
  UNION ALL
  SELECT
    'checkout',
    3,
    SUM(reached_checkout),
    AVG(CASE
      WHEN reached_checkout = 1
      THEN (julianday(first_checkout_time) - julianday(first_page_view)) * 86400
    END)
  FROM funnel_steps
  UNION ALL
  SELECT
    'purchase',
    4,
    SUM(reached_purchase),
    AVG(CASE
      WHEN reached_purchase = 1
      THEN (julianday(first_purchase_time) - julianday(first_page_view)) * 86400
    END)
  FROM funnel_steps
),
total_sessions AS (
  SELECT SUM(reached_page_view) AS total
  FROM funnel_steps
)
SELECT
  sm.funnel_step,
  sm.sessions_reached,
  ROUND(CAST(sm.sessions_reached AS REAL) / ts.total * 100, 2) AS conversion_rate,
  ROUND(sm.avg_seconds, 1) AS avg_time_to_step
FROM step_metrics sm
CROSS JOIN total_sessions ts
ORDER BY sm.step_order`,
      expectedColumns: ['funnel_step', 'sessions_reached', 'conversion_rate', 'avg_time_to_step']
    }
  ]
};

export default analyticsTest;
